import { api } from "./api";
import axios from "axios";

export interface RevenueData {
  RevenueId: number;
  TransactionNumber: string;
  TransactionDate: string;
  Amount: number;
  Remarks: string;
}

export interface SaveRevenueRequest {
  TenantId: number;
  revenueDatas: RevenueData[];
}

export interface SaveRevenueResponse {
  RevenueBatchId: number;
  TotalSuccess: number;
  TotalError: number;
  transactionReturnDatas: Record<string, unknown>[];
  ErrorTransactionNumber: string[];
  Message: string;
  Code: number;
}

export interface RevenueSummaryResponse {
  IsSuccessStatusCode: boolean;
  StatusCode: number;
  ReasonPhrase: string;
  Version: string | null;
  Content: unknown | null;
  Headers: Record<string, string[]>[] | null;
  RequestMessage: unknown | null;
}

export interface RevenueSummaryByMallItem {
  TenantId: number;
  BrandName: string;
  TotalData: number;
  Amount: number;
}

export interface RevenueSummaryByMallContent {
  summaryByMallDatas: RevenueSummaryByMallItem[];
}

export interface RevenueSummaryByMallResponse {
  IsSuccessStatusCode: boolean;
  StatusCode: number;
  ReasonPhrase: string;
  Version: string | null;
  Content: RevenueSummaryByMallContent | null;
  Headers: Record<string, string[]>[] | null;
  RequestMessage: unknown | null;
  summaryByMallDatas?: RevenueSummaryByMallItem[];
  TotalRecord?: number;
  Code?: number;
  Message?: string;
}

export interface RevenueSummaryByBrandItem {
  MallId: number;
  MallName: string;
  TotalData: number;
  Amount: number;
}

export interface RevenueSummaryByBrandContent {
  summaryByBrandDatas: RevenueSummaryByBrandItem[];
}

export interface RevenueSummaryByBrandResponse {
  IsSuccessStatusCode: boolean;
  StatusCode: number;
  ReasonPhrase: string;
  Version: string | null;
  Content: RevenueSummaryByBrandContent | null;
  Headers: Record<string, string[]>[] | null;
  RequestMessage: unknown | null;
  summaryByBrandDatas?: RevenueSummaryByBrandItem[];
}

export interface RevenueTransactionItem {
  RevenueId: number;
  TenantId: number;
  BrandName: string | number;
  MallName: string | number;
  TransactionNumber: string;
  TransactionDate: string;
  Amount: number;
  Remarks: string | null;
}

export interface RevenueTransactionContent {
  revenueDatas: RevenueTransactionItem[];
}

export interface RevenueTransactionResponse {
  IsSuccessStatusCode: boolean;
  StatusCode: number;
  ReasonPhrase: string;
  Version: string | null;
  Content: RevenueTransactionContent | null;
  Headers: Record<string, string[]>[] | null;
  RequestMessage: unknown | null;
  revenueDatas?: RevenueTransactionItem[];
}

export interface RevenueVoidItem {
  RevenueId: number;
  TenantId: number;
  BrandName: string | number;
  MallName: string | number;
  TransactionNumber: string;
  TransactionDate: string;
  Amount: number;
  Remarks: string | null;
}

export interface RevenueVoidContent {
  revenueDatas: RevenueVoidItem[];
}

export interface RevenueVoidResponse {
  IsSuccessStatusCode: boolean;
  StatusCode: number;
  ReasonPhrase: string;
  Version: string | null;
  Content: RevenueVoidContent | null;
  Headers: Record<string, string[]>[] | null;
  RequestMessage: unknown | null;
  revenueDatas?: RevenueVoidItem[];
}

export interface RevenueMonitorItem {
  MallId: number;
  MallName: string;
  TenantId: number;
  BrandName: string;
  TransactionDate: string;
  Amount: number;
}

export interface RevenueMonitorResponse {
  IsSuccessStatusCode: boolean;
  StatusCode: number;
  ReasonPhrase: string;
  Version: string | null;
  Content: unknown | null;
  Headers: Record<string, string[]>[] | null;
  RequestMessage: unknown | null;
  revenueMonitorDatas?: RevenueMonitorItem[];
}

export const SaveRevenue = async (
  tenantId: number,
  revenueDatas: RevenueData[]
): Promise<SaveRevenueResponse | null> => {
  try {
    const payload: SaveRevenueRequest = { TenantId: tenantId, revenueDatas };
    const response = await api.post<SaveRevenueResponse>("/revenue/v1/save", payload);
    if (response.status === 200) return response.data;
    return null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const ValidateSales = async (
  tenantId: number,
  filterDate: string
): Promise<any> => {
  try {
    const token =
      localStorage.getItem("access_token_dev") ||
      sessionStorage.getItem("access_token_dev");
 
    const response = await axios.get(
      `https://devapi.lippomallpuri.com:8443/TenantAccessAPI/api/revenue/v1/salesvalidate`,
      {
        params: {
          tenantid: tenantId,
          filterdate: filterDate,
          page: 0,
          number: 0,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
 
    if (response.status === 200) return response.data;
    return null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const GetRevenueTransaction = async (
  tenantId: number,
  transactionStatus: number,
  startDate: string,
  endDate: string,
  page: number,
  number: number
): Promise<RevenueTransactionResponse | null> => {
  try {
    const response = await api.get<RevenueTransactionResponse>(`/revenue/v1/getrevenue`, {
      params: { tenantid: tenantId, transactionstatus: transactionStatus, startdate: startDate, enddate: endDate, page, number },
    });
    if (response.status === 200) return response.data;
    return null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const GetRevenueVoid = async (
  tenantId: number,
  transactionStatus: number,
  startDate: string,
  endDate: string,
  page: number,
  number: number
): Promise<RevenueVoidResponse | null> => {
  try {
    const response = await api.get<RevenueVoidResponse>(`/revenue/v1/getvoid`, {
      params: { tenantid: tenantId, transactionstatus: transactionStatus, startdate: startDate, enddate: endDate, page, number },
    });
    if (response.status === 200) return response.data;
    return null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const GetRevenueSummary = async (
  tenantId: number,
  year: number,
  month: number
): Promise<RevenueSummaryResponse | null> => {
  try {
    const response = await api.get<RevenueSummaryResponse>(`/revenue/v1/getsummary`, {
      params: { tenantid: tenantId, year, month },
    });
    if (response.status === 200) return response.data;
    return null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const GetRevenueSummaryByMall = async (
  mallId: number,
  year: number,
  month: number
): Promise<RevenueSummaryByMallResponse | null> => {
  try {
    const response = await api.get<RevenueSummaryByMallResponse>(`/revenue/v1/getsummarybymall`, {
      params: { mallid: mallId, year, month },
    });
    if (response.status === 200) return response.data;
    return null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const GetRevenueSummaryByBrand = async (
  year: number,
  month: number
): Promise<RevenueSummaryByBrandResponse | null> => {
  try {
    const response = await api.get<RevenueSummaryByBrandResponse>(`/revenue/v1/getsummarybybrand`, {
      params: { year, month },
    });
    if (response.status === 200) return response.data;
    return null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const GetRevenueMonitorByMall = async (
  mallId: number,
  month: number,
  year: number
): Promise<RevenueMonitorResponse | null> => {
  try {
    const response = await api.get<RevenueMonitorResponse>(`/revenue/v1/getrevenuemonitor`, {
      params: { mallid: mallId, month, year },
    });
    if (response.status === 200) return response.data;
    return null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const GetRevenueMonitorByBrand = async (
  month: number,
  year: number
): Promise<RevenueMonitorResponse | null> => {
  try {
    const response = await api.get<RevenueMonitorResponse>(`/revenue/v1/getrevenuemonitorbybrand`, {
      params: { month, year },
    });
    if (response.status === 200) return response.data;
    return null;
  } catch (error) {
    console.log(error);
    return null;
  }
};